import React from 'react';

const Pharma = () => {
  return (
    <div>
      <h1>Pharma</h1>
    </div>
  );
};

export default Pharma;
